import React from 'react';
import AppSettingsContext from '../context.js';

/*---------------------------------------------*/

export default class BaseTemplate extends React.Component {
	static contextType = AppSettingsContext;

	constructor() {
		super();

		this.container = React.createRef();
	}

	// shouldComponentUpdate(nextProps, nextState) {
	// 	return true;
	// }

	componentDidUpdate(prevProps) {
	}
}

/*---------------------------------------------*/

